'use client';

import type { ComponentProps, SyntheticEvent } from 'react';

import { playImageReveal } from '@/lib/image-reveal';
import { mergeClassNames } from '@/lib/utils';

// Only a photo still loading when it mounts waits hidden; one from the cache,
// or one that loaded before hydration, shows at once with no animation.
const holdUntilLoaded = (img: HTMLImageElement | null) => {
  if (img && !img.complete) img.dataset.reveal = 'pending';
};

const reveal = (event: SyntheticEvent<HTMLImageElement>) => {
  const img = event.currentTarget;
  if (img.dataset.reveal !== 'pending') return;
  delete img.dataset.reveal;
  if (event.type === 'load') playImageReveal(img);
};

export const RevealImage = ({
  alt,
  className,
  ...props
}: Omit<ComponentProps<'img'>, 'alt' | 'ref' | 'onLoad' | 'onError'> & {
  alt: string;
}) => (
  <img
    {...props}
    ref={holdUntilLoaded}
    alt={alt}
    onLoad={reveal}
    onError={reveal}
    className={mergeClassNames('data-[reveal=pending]:opacity-0', className)}
  />
);
